import { render, staticRenderFns } from "./RollingReserve.vue?vue&type=template&id=bb5545ec"
import script from "./RollingReserve.vue?vue&type=script&lang=js"
export * from "./RollingReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports